import styled from 'styled-components';
import { EBalancesTheme } from './types';

export const StyledHeader = styled.div`
  font-family: var(--font-family);
  display: flex;
  min-height: 84px;
  max-width: 400px;
  height: fit-content;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 40px ${({ isProfileInfo }: any) => (isProfileInfo ? '0' : '44px')} 0
    1em;
  padding-right: 1em;
  position: relative;
  z-index: 1;
  margin: 0 auto;
  box-sizing: content-box;
  visibility: ${(props: any) => props.visibility};
  background: ${(props: any) => props.backgroundColor};
  flex-wrap: wrap;

  &.pipa {
    min-height: auto;
    padding: 0;
    margin: 40px 16px 0 16px;
      width: calc(100% - 32px);

    .profileContainer {
      height: 36px;
      width: 36px;

      .frame {
        height: 36px;
        width: 36px;
      }

      &-info {
        margin-left: 3px;
        flex-direction: row;
        color: #733200;
        align-items: center;
        justify-content: start;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        gap: 0;

        .playerName {
          margin-right: 8px;
        }
      }
    }
  }

  .logo {
    width: ${({ isProfileInfo }: any) => (isProfileInfo ? 'auto' : '128px')};
    height: ${({ isProfileInfo }: any) => (isProfileInfo ? '60px' : 'auto')};
    margin: ${({ isProfileInfo }: any) => (isProfileInfo ? '0' : 'auto')};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
     ${({ hasBadge, isProfileInfo }: any) =>
        hasBadge && isProfileInfo && 
          `
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
          `
        }

    &__main {
      width: ${({ isProfileInfo }: any) => (isProfileInfo ? 'unset' : '100%')};
      height: ${({ isProfileInfo }: any) => (isProfileInfo ? '100%' : 'unset')};
      object-fit: contain;
    }

    &__sub {
      width: 150%;
    }
  }

  .profileContainer {
    margin-bottom: ${({ balanceTheme }: any) =>
      balanceTheme === EBalancesTheme.PLAY_SIMPLE ? '16px' : '0'};
    cursor: pointer;
    height: ${({ isProfileInfo }: any) =>
      isProfileInfo ? 'fit-content' : '44px'};
    display: ${({ isProfileInfo }: any) => (isProfileInfo ? 'flex' : 'block')};
    align-items: ${({ isProfileInfo }: any) =>
      isProfileInfo ? 'center' : 'none'};
    flex: ${({ isProfileInfo, hasBadge }: any) => {
      if (hasBadge && isProfileInfo) return 'none';
      return isProfileInfo ? '1' : '0';
    }};

    .frame {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: ${({ isProfileInfo }: any) => (isProfileInfo ? '40px' : '44px')};
      width: ${({ isProfileInfo }: any) => (isProfileInfo ? '40px' : '44px')};
      border-radius: 50%;
      margin-right: 5px;
    }

    &__profileFrame {
      position: absolute;
      height: ${({ isProfileInfo }: any) => (isProfileInfo ? '36px' : '44px')};
      width: ${({ isProfileInfo }: any) => (isProfileInfo ? '36px' : '44px')};
    }

    &__img {
      height: 90%;
      border-radius: 50%;
      background-color: gray;
    }

    &-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: fit-content;
      flex: 1;
      gap: 2px;
      margin-left: 4px;
      color: white;
      font-size: 12px;
      line-height: normal;
      font-weight: 400;

      & > div:nth-child(2) {
        align-items: flex-start;
      }
    }

    .bagelCodeInfoContainer {
      margin-left: 4px;
    }
  }

  .badgesContainer {
    display: flex;
    gap: 15px;
    position: ${({ isProfileInfo }: any) => (isProfileInfo ? 'static' : 'absolute')};
    right: 0;

    @media only screen and (max-width: 767px) {
      justify-content: flex-start;
      margin-top: 10px;
      position: static;
      width: 100%;
    }
  }

  @media only screen and (orientation: landscape) and (max-width: 1280px) {
    padding: 40px 60px 0 0;
    margin: 0 24px;
  }

  @media only screen and (min-width: 768px) {
    padding-right: ${({ isProfileInfo }: any) =>
      isProfileInfo ? '0' : '60px'};

    &.pipa {
      .profileContainer {
        height: 36px;
        width: 36px;

        .frame {
          height: 36px;
          width: 36px;
        }
      }
    }

    .profileContainer {
      height: ${({ isProfileInfo }: any) =>
        isProfileInfo ? 'fit-content' : '60px'};
      width: ${({ isProfileInfo }: any) =>
        isProfileInfo ? 'fit-content' : '60px'};

      .frame {
        height: ${({ isProfileInfo }: any) =>
          isProfileInfo ? '48px' : '60px'};
        width: ${({ isProfileInfo }: any) => (isProfileInfo ? '48px' : '60px')};
      }

      &-info {
        font-size: 1rem;
        margin-left: 8px;
      }

      &__profileFrame {
        height: ${({ isProfileInfo }: any) =>
          isProfileInfo ? '48px' : '60px'};
        width: ${({ isProfileInfo }: any) => (isProfileInfo ? '48px' : '60px')};
      }
    }

    .logo {
      width: ${({ isProfileInfo }: any) => (isProfileInfo ? 'auto' : '180px')};
      height: ${({ isProfileInfo }: any) => (isProfileInfo ? '64px' : 'auto')};

      &.big {
        width: 176px;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    height: ${({ isProfileInfo, hasBadge }: any) =>
      isProfileInfo ? 'fit-content' : hasBadge ? '220px' : '120px'};
    max-width: ${(props: any) => (props.fullWidth ? '100%' : '400px')};
    .defaultInfoLogo {
      ${({ hasBadge }: any) =>
        hasBadge
          ? `
            margin-top: 10px;
          `
          : `
            position: absolute;
            left: 50%;
            transform: translate(-50%);
          `}}
    }

    &.pipa {
      height: auto;
    }

    .logo {
      ${({ hasBadge, isProfileInfo }: any) =>
        hasBadge && isProfileInfo &&
          `
            position: static;
            transform: 0;
          `
      }
    }
  }

  @media only screen and (min-width: 1024px) {
    .logo {
      width: ${({ isProfileInfo }: any) => (isProfileInfo ? 'auto' : '196px')};
      height: ${({ isProfileInfo }: any) => (isProfileInfo ? '64px' : 'auto')};

      &.big {
        width: 220px;
      }
    }
  }

  @media only screen and (min-width: 1280px) {
    max-width: 1248px;

    &.pipa {
      max-width: 400px;
    }
  }

  @media only screen and (min-width: 849px) and (max-width: 1279px) {
    max-width: 820px;

    &.pipa {
      max-width: 400px;
    }
  }
` as any;
